export default "__VITE_ASSET__Bo3YwZ5Y__"